import { Card, Row } from 'antd';
import styled from 'styled-components';

export const TableView = styled(Card)`
  width: 400px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  .ant-card-body {
    padding: 10px;
  }
`;

export const TableRow = styled(Row)`
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableDes = styled.p`
  line-height: 1;
`;
